import {type PrismicDocument} from '@prismicio/types';
import {useLocale, useRoute, useSeoMeta} from '#imports';

export function useDefineSeoAndMetaTags(document: PrismicDocument) {
    const {isMultiLocaleHost} = useLocale();
    const route = useRoute();

    const seo = document.data;
    const title = seo.metaTitle ?? document.data.title;
    const description = seo.metaDescription ?? document.data.title;
    const ogTitle = seo.openGraphTitle || title;
    const ogDescription = seo.openGraphDescription || description;
    const ogImage = seo.openGraphImage || '';

    useSeoMeta({
        ...((isMultiLocaleHost.value || seo.noIndex) && {robots: 'noindex'}),
        title,
        description,
        ogTitle,
        ogDescription,
        ogImage,
        ogUrl: route.fullPath,
        twitterCard: 'summary',
        twitterImage: ogImage,
        twitterTitle: title,
        twitterDescription: description,
    });
}
